// App.js

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// ================= DISTRIBUTOR =================

import AppLayout from "./AppLayout";
import Dashboard from "./dashboard";
import SchemeTypeMapping from "./SchemeTypeMapping";
import ArnCreation from "./arn_creation";
import DistributorLogin from "./DistributorLogin";
import ManageFamilyGroup from "./managefamilygroup";
import FamilyLedgerView from "./components/ledger/FamilyLedgerView";
import LedgerView from "./components/ledger/LedgerView";
import UploadHealthPolicy from "./UploadHealthPolicy";
import AMCSchemeReport from "./AMCSchemeReport";
import ClientMasterReport from "./ClientMasterReport";
import ReportDownloads from "./ReportDownloads";
import ChangeArnPassword from "./ChangeArnPassword";

// ================= CLIENT =================

import AppLayoutForClient from "./AppLayoutForClient";
import DashboardForClient from "./DashboardForClient";
import ClientLogin from "./ClientLogin";


function App() {
  return (
    <BrowserRouter>

      <Routes>

        {/* =====================================================
            DISTRIBUTOR LOGIN
        ===================================================== */}

        <Route
          path="/login"
          element={<DistributorLogin />}
        />


        {/* =====================================================
            DISTRIBUTOR PORTAL

            Permanent Distributor Layout / Side Menu
        ===================================================== */}

        <Route
          path="/"
          element={<AppLayout />}
        >

          <Route
            index
            element={<Dashboard />}
          />

          <Route
            path="dashboard"
            element={<Dashboard />}
          />

          <Route
            path="ledger"
            element={<LedgerView />}
          />

          <Route
            path="family_ledger"
            element={<FamilyLedgerView />}
          />

          <Route
            path="amc-scheme-report"
            element={<AMCSchemeReport />}
          />

          <Route
            path="schemetypemapping"
            element={<SchemeTypeMapping />}
          />

          <Route
            path="managefamilygroup"
            element={<ManageFamilyGroup />}
          />

          <Route
            path="arn_creation"
            element={<ArnCreation />}
          />


          <Route
            path="change-arn-password"
            element={<ChangeArnPassword />}
          />

          <Route
            path="upload-health-policy"
            element={<UploadHealthPolicy />}
          />

          <Route
            path="client-master-report"
            element={<ClientMasterReport />}
          />

          <Route
            path="report-downloads"
            element={<ReportDownloads />}
          />

        </Route>


        {/* =====================================================
            CLIENT LOGIN

            Login / Signup screen has NO side menu
        ===================================================== */}

        <Route
          path="/client/login"
          element={<ClientLogin />}
        />


        {/* =====================================================
            CLIENT PORTAL

            Client has its OWN permanent side menu/layout.
            Distributor AppLayout is NOT used here.
        ===================================================== */}

        <Route
          path="/client"
          element={<AppLayoutForClient />}
        >

          <Route
            path="dashboard"
            element={<DashboardForClient />}
          />

        </Route>


      </Routes>

    </BrowserRouter>
  );
}


export default App;